// import external dependencies
// import depencency from 'node-modules-subfolder';

export default {
  init() {
    // JavaScript to be fired on home

  },
  finalize() {
    // JavaScript to be fired on home, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js